export default {
  ADD_REQUESTS (state, requests) {
    state.serviceRequests = requests.serviceRequests
    state.consultationRequests = requests.consultationRequests
  },
  DELETE_SERVICE_REQUEST (state, id) {
    state.serviceRequests = state.serviceRequests.filter(d => d.id !== id)
  },
  DELETE_CONSULTATION_REQUEST (state, id) {
    state.consultationRequests = state.consultationRequests.filter(d => d.id !== id)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/serviceRequests.js